import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useThemeStore from '../store/useThemeStore';
import useInboxStore from '../store/useInboxStore';

// icon(active, isDark) — isDark passed at render time, not module scope
const navItems = [
  {
    path: '/home',
    icon: (active, isDark) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? '#fff' : 'none'} stroke={active ? '#fff' : (isDark ? '#8E8E93' : '#555555')} strokeWidth="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    )
  },
  {
    path: '/inbox',
    icon: (active, isDark) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? '#fff' : (isDark ? '#8E8E93' : '#555555')} strokeWidth="2">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
      </svg>
    )
  },
  {
    path: '/explore',
    icon: (active, isDark) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? '#fff' : (isDark ? '#8E8E93' : '#555555')} strokeWidth="2">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
    )
  },
  {
    path: '/bookings',
    icon: (active, isDark) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? '#fff' : (isDark ? '#8E8E93' : '#555555')} strokeWidth="2">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
      </svg>
    )
  },
  {
    path: '/account',
    icon: (active, isDark) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? '#fff' : (isDark ? '#8E8E93' : '#555555')} strokeWidth="2">
        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
    )
  }
];

const HIDDEN_PATHS = ['/provider-setup', '/client-setup', '/auth'];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { theme } = useThemeStore();
  const { unreadCount } = useInboxStore();
  const isDark = theme === 'dark';

  if (HIDDEN_PATHS.includes(pathname)) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 flex justify-center"
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 12px)', paddingTop: 8 }}
    >
      <nav
        className="flex items-center gap-1 px-2 py-2 rounded-full"
        style={{
          background: isDark ? 'rgba(28, 28, 30, 0.3)' : 'rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          boxShadow: isDark ? '0 8px 32px rgba(0,0,0,0.5)' : '0 8px 32px rgba(0,0,0,0.12)',
          border: isDark ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(0,0,0,0.06)'
        }}
      >
        {navItems.map((item) => {
          const active = pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="relative flex items-center justify-center transition-all duration-200"
              style={{
                width: active ? 52 : 44,
                height: 44,
                borderRadius: 22,
                background: active ? 'rgba(108, 92, 231, 0.9)' : 'transparent',
              }}
            >
              {item.icon(active, isDark)}
              {item.path === '/inbox' && unreadCount > 0 && !active && (
                <span className="absolute top-1 right-1 min-w-[16px] h-4 bg-red-500 rounded-full text-white text-[9px] font-bold flex items-center justify-center px-0.5 leading-none">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
